import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { commonProperties } from '../../../assets/environments/environment.common';
import { GuestTokenModel } from '../models/superset/GuestToken.model';
import { firstValueFrom } from 'rxjs';
import { BoardModel } from '../models/superset/board.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import {environment} from '../../../assets/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private current_guest_token?: string = undefined;
  current_boards?: BoardModel[] = undefined;


  constructor(
      private httpClient: HttpClient,
      private jwtService: JwtHelperService
    ) { }

    async getGuestToken(): Promise<string>{
      if(this.current_guest_token == undefined || this.jwtService.isTokenExpired(this.current_guest_token))
      {
        let params = new HttpParams();
        params = params.set('dashboardNames', 'MARKETPLACE,MISSION');
        let result = await firstValueFrom(this.httpClient.get<GuestTokenModel>(environment.api_root + commonProperties.superset, {params}));

        this.current_guest_token = result.token;
        this.current_boards = result.boards;
      }

      return this.current_guest_token;
    }

    clearToken() {
      this.current_guest_token = undefined;
    }

}
